// client/src/routes/app/tenants/$tenantId/contacts.tsx — SCR-TEN-002 tab „Contacte" · TEN-004.

import { createFileRoute } from '@tanstack/react-router';

import { ContactsTab } from '@/features/tenants/ContactsTab';

export const Route = createFileRoute('/app/tenants/$tenantId/contacts')({
  component: ContactsTabScreen,
});

function ContactsTabScreen() {
  const { tenantId } = Route.useParams();
  return <ContactsTab tenantId={tenantId} />;
}
